import React, { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";
import logo from "../components/assets/logoBwarga.svg";
import logoWhite from "../components/assets/logoBWargaWhite.svg";

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [activeSection, setActiveSection] = useState("home");

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);

      const sections = ["home", "features", "benefits", "contact"];
      const scrollPosition = window.scrollY;
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;

      if (scrollPosition + windowHeight >= documentHeight - 50) {
        setActiveSection("contact");
        return;
      }

      for (let i = sections.length - 1; i >= 0; i--) {
        const section = sections[i];
        const element = document.getElementById(section);

        if (element) {
          const rect = element.getBoundingClientRect();
          const offsetTop = element.offsetTop;

          if (scrollPosition >= offsetTop - 200) {
            setActiveSection(section);
            break;
          }
        }
      }
    };

    let timeoutId;
    const debouncedHandleScroll = () => {
      if (timeoutId) {
        window.cancelAnimationFrame(timeoutId);
      }
      timeoutId = window.requestAnimationFrame(() => {
        handleScroll();
      });
    };

    window.addEventListener("scroll", debouncedHandleScroll, { passive: true });

    handleScroll();

    return () => {
      window.removeEventListener("scroll", debouncedHandleScroll);
      if (timeoutId) {
        window.cancelAnimationFrame(timeoutId);
      }
    };
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      setActiveSection(id);
      setIsMobileMenuOpen(false);

      setTimeout(() => {
        const offsetTop = element.offsetTop - 80;

        window.scrollTo({
          top: offsetTop,
          behavior: "smooth",
        });
      }, 10);
    }
  };

  const menuItems = [
    { id: "home", label: "Beranda" },
    { id: "features", label: "Fitur" },
    { id: "benefits", label: "Keuntungan" },
    { id: "contact", label: "Kontak" },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? "bg-white shadow-lg" : "bg-white/1 backdrop-blur-sm"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <div className="flex items-center">
            <img
              src={isScrolled ? logo : logoWhite}
              alt="Logo BWarga"
              className={`h-8 w-auto transition-all duration-300`}
            />
          </div>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center space-x-8">
            {menuItems.map((item) => (
              <button
                key={item.id}
                onClick={() => scrollToSection(item.id)}
                className={`relative transition-all duration-200 font-medium ${
                  isScrolled
                    ? activeSection === item.id
                      ? "text-teal-600"
                      : "text-gray-700 hover:text-teal-600"
                    : activeSection === item.id
                      ? "text-teal-100"
                      : "text-white hover:text-teal-100"
                }`}
              >
                {item.label}
                <span
                  className={`absolute -bottom-1 left-0 w-full h-0.5 rounded-full transition-all duration-200 ${
                    activeSection === item.id
                      ? isScrolled
                        ? "bg-teal-600 opacity-100"
                        : "bg-teal-100 opacity-100"
                      : "bg-transparent opacity-0"
                  }`}
                ></span>
              </button>
            ))}
          </div>

          {/* Mobile Menu Button */}
          <button
            className={`md:hidden transition-colors ${isScrolled ? "text-gray-700" : "text-white"}`}
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden bg-white border-t">
            <div className="px-2 pt-2 pb-3 space-y-1">
              {menuItems.map((item) => (
                <button
                  key={item.id}
                  onClick={() => scrollToSection(item.id)}
                  className={`block w-full text-left px-3 py-2 rounded font-medium transition-all duration-200 ${
                    activeSection === item.id
                      ? "bg-teal-50 text-teal-600"
                      : "text-gray-700 hover:bg-teal-50"
                  }`}
                >
                  {item.label}
                </button>
              ))}
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
